class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.details = this.mainDetailsToggle;
    this.summary = this.details.querySelector('summary');
    this.closeTimeout = null;

    // Desktop: open on hover, click navigates to link
    this.details.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.details.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onMouseEnter() {
    if (window.innerWidth < 990) return;
    clearTimeout(this.closeTimeout);
    this.open();
  }

  onMouseLeave() {
    if (window.innerWidth < 990) return;
    this.closeTimeout = setTimeout(() => this.close(), 200);
  }

  onSummaryClick(e) {
    if (window.innerWidth < 990) return;
    e.preventDefault();
    const url = this.summary.getAttribute('data-url');
    if (url) window.location.href = url;
  }

  open() {
    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Se re-mide en cada apertura: Dawn la seteaba una sola vez, pero con el
    // sticky on-scroll-up el fondo del header cambia (143px con announcement
    // bar arriba vs 84px pegado al tope) y el max-height del panel quedaba
    // calculado con la medida vieja — en viewports bajos lo recortaba a nada.
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
